import { useState, useEffect } from 'react';
import api from '../services/api';

export function useLeaveTypes() {
  const [leaveTypes, setLeaveTypes] = useState([]);

  useEffect(() => {
    let cancelled = false;

    api.get('/leave-types')
      .then((response) => {
        if (!cancelled) {
          setLeaveTypes(response.data || []);
        }
      })
      .catch((error) => {
        console.error('Failed to fetch leave types:', error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return leaveTypes;
}
